import { render, staticRenderFns } from "./waiting-to-confirm.vue?vue&type=template&id=08257ac0&scoped=true&"
import script from "./waiting-to-confirm.vue?vue&type=script&lang=js&"
export * from "./waiting-to-confirm.vue?vue&type=script&lang=js&"
import style0 from "./waiting-to-confirm.vue?vue&type=style&index=0&id=08257ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08257ac0",
  null
  
)

export default component.exports